import { render, staticRenderFns } from "./WaterRoad.vue?vue&type=template&id=c9fab26c&scoped=true&"
import script from "./WaterRoad.vue?vue&type=script&lang=js&"
export * from "./WaterRoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fab26c",
  null
  
)

export default component.exports